import { type ActiveFiltersType } from '@bytel/product-wall';

import { type WallConfigType } from '@app-types/config';
import { type TrackingVariantType } from '@app-types/tracking';

const trackingFilterKeys: Record<string, string> = {
    marque: 'marques',
    prix: 'prix',
    disponibleCnc: 'modeLivraison',
    telephoneAvec: 'bonsPlans',
    etat: 'etat',
    systemeExploitation: 'systeme',
};

export function getPhoneWallTrackingVariant(
    activeFilters: ActiveFiltersType,
    wallConfig: WallConfigType,
): TrackingVariantType {
    const getFilterLabels = (filterKey: string, activeFilterValues: string[]) => {
        const filter = wallConfig.filtersObject[filterKey];

        if (!filter || !('values' in filter) || !filter.values) {
            return activeFilterValues;
        }

        return activeFilterValues.map(
            (activeFilter) =>
                Object.values(filter.values).find((filterValue) => filterValue.value === activeFilter)?.label ??
                activeFilter,
        );
    };

    const pageVariant: TrackingVariantType = {
        smartChange: activeFilters.sousType?.includes('smart-change') ?? false,
    };

    Object.entries(activeFilters).forEach(([filterKey, activeFilterValues]) => {
        if (filterKey === 'sousType' || !activeFilterValues?.length) {
            return;
        }

        const trackingKey = trackingFilterKeys[filterKey] ?? filterKey;
        pageVariant[trackingKey] = trackingFilterKeys[filterKey]
            ? getFilterLabels(filterKey, activeFilterValues)
            : activeFilterValues;
    });

    return pageVariant;
}
